import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { Action } from '@ngrx/store';
import { setPassword, requestSuccess, requestError } from './actions';
import { ErrorInterface } from '../../interfaces/general.interface';

@Injectable()
export class SetPasswordEffect {
  constructor(private service: AuthService, private actions$: Actions) {}

  public setPassword$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(setPassword),
      switchMap((payload: { password: string; token: string }) =>
        this.service.setPassword(payload).pipe(
          map((response: any) => {
            if (response.errorCode.code !== 0) {
              if (response.details && typeof response.details === 'string') {
                response.errorCode.details = response.details;
              }
              throw response.errorCode; //for reading the details
            }
            return requestSuccess({ response });
          }),
          catchError((error: ErrorInterface) => of(requestError({ error })))
        )
      )
    );
  });
}
